import { Button } from '@/components/ui/button';
import { GoogleIcon } from '@/components/icons/GoogleIcon';
import { useAuth } from '@/lib/auth';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type GoogleContinueButtonProps = React.ComponentProps<typeof Button>;

export function GoogleContinueButton({
  className,
  ...props
}: GoogleContinueButtonProps) {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth({
    middleware: 'guest',
    redirectTo: '/',
    tmp: 'GoogleContinueButton',
  });

  return (
    <Button
      type="button"
      variant="outline"
      className={cn(
        'h-[50px] w-full gap-2 rounded-[6px] border-border-strong bg-white font-label uppercase text-brand-secondary-dark hover:bg-brand-secondary-dark/5 dark:bg-card dark:text-foreground dark:hover:bg-muted dark:hover:text-foreground',
        className,
      )}
      onClick={() => loginWithGoogle()}
      {...props}
    >
      <GoogleIcon className="h-4 w-4 shrink-0" />
      {t('auth.google.continueButton')}
    </Button>
  );
}
